import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface InputProps {
  error?: boolean;
  fullWidth?: boolean;
}

export const Input = styled.input<InputProps>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  border: 2px solid ${({ error, theme }) => error ? theme.colors.error : theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: 16px;
  transition: all ${({ theme }) => theme.transitions.fast};
  background-color: ${({ theme }) => theme.colors.cardBackground};

  &:focus {
    outline: none;
    border-color: ${({ error, theme }) => error ? theme.colors.error : theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ error, theme }) => 
      error ? `${theme.colors.error}20` : `${theme.colors.primary}20`};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.textLight};
    opacity: 0.5;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 16px;
    padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  }
`;

export const TextArea = styled.textarea<InputProps>`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.md}`};
  border: 2px solid ${({ error, theme }) => error ? theme.colors.error : theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: 16px;
  resize: vertical;
  min-height: 100px;
  transition: all ${({ theme }) => theme.transitions.fast};
  background-color: ${({ theme }) => theme.colors.cardBackground};
  line-height: 1.6;

  &:focus {
    outline: none;
    border-color: ${({ error, theme }) => error ? theme.colors.error : theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ error, theme }) => 
      error ? `${theme.colors.error}20` : `${theme.colors.primary}20`};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.textLight};
    opacity: 0.5;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 16px;
    padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
  }
`;